import { gql } from "@apollo/client";

export const GET_MEMBER_PAFINATION = gql`
  query GetMemberPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getMemberPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        profile
        gender
        phoneNumber
        email
        role
        telegram
        latinName
        dateOfBirth
        nationalIdCardNumber
        firstNameKh
        lastNameKh
        currentAddress {
          capical_provinces_id {
            _id
            capital_province_name_en
            capital_province_name_kh
          }
          district_municipalities_id {
            _id
            district_municipality_name_kh
            district_municipality_name_en
          }
          commune_sangkat_id {
            _id
            commune_sangkat_name_kh
            commune_sangkat_name_en
          }
          village_id {
            _id
            village_name_kh
            village_name_en
          }
        }
        placeOfBirth {
          capical_provinces_id {
            _id
            capital_province_name_en
            capital_province_name_kh
          }
          district_municipalities_id {
            _id
            district_municipality_name_kh
            district_municipality_name_en
          }
          commune_sangkat_id {
            _id
            commune_sangkat_name_kh
            commune_sangkat_name_en
          }
          village_id {
            _id
            village_name_kh
            village_name_en
          }
        }
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_MEMBER_IN_MANDATE_PAGINATION = gql`
  query GetMemberInMandatePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $partyId: String
    $isActive: Boolean
  ) {
    getMemberInMandatePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      partyId: $partyId
      isActive: $isActive
    ) {
      data {
        _id 
        mandateId {
          _id
          mandateName
          startDate
          endDate
          isActive
          remark
          totalMember
          totalParty
          parties {
            _id
            partyName
            logo
            remark
          }
        }
        memberId {
          _id
          profile
          firstNameKh
          lastNameKh
          gender
          phoneNumber
          telegram
          email
          role
          latinName
          dateOfBirth
          placeOfBirth {
            capical_provinces_id {
              _id
              capital_province_name_en
              capital_province_name_kh
            }
            district_municipalities_id {
              _id
              district_municipality_name_kh
              district_municipality_name_en
            }
            commune_sangkat_id {
              _id
              commune_sangkat_name_kh
              commune_sangkat_name_en
            }
            village_id {
              _id
              village_name_kh
              village_name_en
            }
          }
          nationalIdCardNumber
          currentAddress {
            capical_provinces_id {
              _id
              capital_province_name_en
              capital_province_name_kh
            }
            district_municipalities_id {
              _id
              district_municipality_name_kh
              district_municipality_name_en
            }
            commune_sangkat_id {
              _id
              commune_sangkat_name_kh
              commune_sangkat_name_en
            }
            village_id {
              _id
              village_name_kh
              village_name_en
            }
          }
          remark
        }
        positions {
          _id
          positionsNameKh
          positionsNameEng
        }
        fromParty {
          _id
          partyName
          logo
          remark
        }
        isLossOfMembership
        numbering
        candidateId {
          numberOrder
          _id
        }
        startDate
        resignDate
        reason {
          _id
          reason_title
          isDefault
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_MEMBER = gql`
  mutation CreateMember($input: MemberInput) {
    createMember(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
      data {
        _id
        firstNameKh
        latinName
        lastNameKh
      }
    }
  }
`;

export const UPDATE_MEMBER = gql`
  mutation UpdateMember($id: ID!, $input: MemberInput) {
    updateMember(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_MEMBER = gql`
  mutation DeleteMember($id: ID!) {
    deleteMember(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_MEMBER_IN_MANDATE = gql`
  mutation CreateMemberInMandate($input: MemberInMandateInput) {
    createMemberInMandate(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_MEMBER_IN_MANDATE = gql`
  mutation UpdateMemberInMandate($id: ID!, $input: MemberInMandateInput) {
    updateMemberInMandate(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_NEXT_NUMBER_MEMBER_IN_MANDATE = gql`
  query Query {
    getNextNumberingMemberInMandate
  }
`;

export const DELETE_MEMBER_IN_MANDATE = gql`
  mutation DeleteMemberInMandate($id: ID!) {
    deleteMemberInMandate(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const LOSS_OF_MEMBERSHIP = gql`
  mutation LossOfMembership($id: ID!, $input: LossOfMembershipInput) {
    lossOfMembership(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_MEMBER_BY_ID = gql`
  query GetMemberById($id: ID!) {
    getMemberById(_id: $id) {
      _id
      profile
      firstNameKh
      lastNameKh
      gender
      phoneNumber
      email
      role
      telegram
      latinName
      dateOfBirth
      placeOfBirth {
        capical_provinces_id {
          _id
          capital_province_name_en
          capital_province_name_kh
        }
        district_municipalities_id {
          _id
          district_municipality_name_kh
          district_municipality_name_en
        }
        commune_sangkat_id {
          _id
          commune_sangkat_name_kh
          commune_sangkat_name_en
        }
        village_id {
          _id
          village_name_kh
          village_name_en
        }
      }
      nationalIdCardNumber
      currentAddress {
        capical_provinces_id {
          _id
          capital_province_name_en
          capital_province_name_kh
        }
        district_municipalities_id {
          _id
          district_municipality_name_kh
          district_municipality_name_en
        }
        commune_sangkat_id {
          _id
          commune_sangkat_name_kh
          commune_sangkat_name_en
        }
        village_id {
          _id
          village_name_kh
          village_name_en
        }
      }
      remark
    }
  }
`;
